<template>
  <header class="brand-header">
    <div class="bh-left">
      <img :src="brand.icon ?? '/brand/logo-icon.png'" alt="" class="bh-icon" />
      <span class="bh-title">{{ title }}</span>
    </div>
    <CountdownTimer />
  </header>
</template>

<script setup lang="ts">
import CountdownTimer from "./CountdownTimer.vue";
import { useBrand } from "@/composables/useBrand";

defineProps<{ title: string }>();

const { brand } = useBrand();
</script>

<style scoped>
.brand-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px 10px;
  background: var(--bg-black);
}
.bh-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.bh-icon {
  height: 22px;
  width: auto;
  display: block;
  flex-shrink: 0;
}
.bh-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--brand-green);
  letter-spacing: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

@media (max-width: 360px) {
  .bh-icon { height: 20px; }
  .bh-title { font-size: 15px; }
}
</style>
